import React, { Component } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import DocumentsDetailPres from 'src/ui/features/Documents/presentational/DocumentsDetailPres';
import { isCorpClientSelector } from '../../../../ui/features/Login/state/loginReselect';
import { getDocumentDetailsHeader, deHydrateDocumentDetails } from '../state/documentsActions';
import { addToHistory } from 'src/utils/utilsActions';
import { history } from 'src/store/configureStore';
import { PageTitle } from 'src/ui/library/PageTitle';

export class DocumentsDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
    };
  }

  componentDidMount() {
    const { caseId, documentId, documentKey } = this.props.match.params;
    this.props.addToHistory(window.location.pathname, { caseId, documentId, documentKey });
    this.props.getDocumentDetailsHeader(documentId, history.goBack);
  }

  componentWillUnmount() {
    this.props.deHydrateDocumentDetails();
  }

  tabsHandler = (event, value) => {
    this.setState({
      tab: value,
    });
  };

  render() {
    return (
      <React.Fragment>
        <PageTitle title={intl.get('documents.documentDetails.pageTitle')} />
        <DocumentsDetailPres {...this.props} handleTabSelect={this.tabsHandler} tab={this.state.tab} />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  addToHistory,
  getDocumentDetailsHeader,
  deHydrateDocumentDetails,
};

const mapStateToProps = state => ({
  documentDetail: state.documents.documentDetail,
  documentDetailName: state.documents.documentDetailName,
  documentDetailType: state.documents.documentDetailType,
  documentDetailSubtype: state.documents.documentDetailSubtype,
  documentDetailEmployeeName: state.documents.documentDetailEmployeeName,
  documentDetailEmployeeGUID: state.documents.documentDetailEmployeeGUID,
  isLoading: state.documents.isLoading,
  isCorpClient: isCorpClientSelector(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsDetailContainer);
